import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { IframeFullDoc } from 'modules/secureIframe/IframeFullDoc';

export const ContentPreviewContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: ${spacing.base};
    grid-template-rows: auto;

    @media only screen and (max-width: 1080px) {
        grid-template-columns: 1fr;
    }
`;

export const StyledIframeFullDoc = styled(IframeFullDoc)`
  width: 100%;
  overflow-x: auto;
`;

export const StyledDL = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: ${spacing.half};
  row-gap: ${spacing.eighth};
`;
